import React, { useContext, useEffect, useState } from 'react'
import CustomImage from '../../components/customImage/customImage'
// import Filter from './filter'
import dropDownArror from '../../assets/dropdown-svgrepo-com-1@3x.png'
import shoppingCart from '../../assets/shopping-cart-favorite-02@3x.png'
import handBag from '../../assets/handbag@3x.png'
import transactionIcon from '../../assets/transaction-svgrepo-com@3x.png'
import TransactionDetailModal from './transactionDetailModal'
import { ECOMMERCE_ORDER } from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import { getProductImage, getReleaseDate, snakeToTitle } from '../../utils/helper'
import useTemplateHook from '../../components/template/templateHook'
import { useNavigate } from 'react-router'
import getSymbolFromCurrency from 'currency-symbol-map'
import { IoIosInformationCircleOutline } from 'react-icons/io'

const OrderHistory = () => {
  const { getTemplateImage } = useTemplateHook()
  const { setLoader } = useContext(AppContext)
  const navigate = useNavigate()

  const [open, setOpen] = useState(false)
  const [expandedOrderId, setExpandedOrderId] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [selectedTransaction, setSelectedTransaction] = useState(null)
  const [orders, setOrders] = useState([])

  const [{ data: orderData, loading: orderDataLoading }, orderDataCall] = useAxios(
    {
      url: `${ECOMMERCE_ORDER}/list`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    orderDataCall()
  }, [])

  useEffect(() => {
    setLoader(orderDataLoading)
  }, [orderDataLoading])

  useEffect(() => {
    if (orderData && orderData.success) {
      setOrders(
        orderData?.data.sort((a, b) => new Date(b.modified_date) - new Date(a.modified_date)),
      )
    }
  }, [orderData])

  const toggleOrderExpansion = (orderId) => {
    setExpandedOrderId((prev) => (prev === orderId ? null : orderId))
  }

  const getStatusColor = (status) => {
    if (status === 'delivered') {
      return '#16d800'
    }
    return '#ffff00'
  }

  return (
    <div className="w-full mt-2 xl:mt-4">
      <div className="flex justify-center px-3  md:px-6 items-center">
        <div className="w-full max-w-[890px]">
          {/* Header */}
          <div className="flex justify-between items-center mb-6 relative">
            <div className="flex items-center gap-2" onClick={() => setOpen(!open)}>
              <p className="text-white font-semibold text-sm md:text-lg lg:text-xl">
                Order History
              </p>
              <CustomImage
                imageUrl={dropDownArror}
                imgAlt={'dropDownArror'}
                imgClass={`w-5 h-5 object-contain ml-auto transform transition-transform lg:hidden ${
                  open ? 'rotate-180' : ''
                }`}
              />
            </div>
            <div className="flex gap-3 items-center">
              <div className="hidden lg:flex gap-3">
                <button
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    border: 'solid 1px #f60',
                  }}
                  onClick={() => navigate(`/wish-list`)}
                >
                  <CustomImage imageUrl={shoppingCart} imgAlt="cart" imgClass="w-4 h-4" />
                  <span>Wishlist</span>
                </button>
                <button
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                  }}
                  onClick={() => navigate(`/store`)}
                >
                  <CustomImage imageUrl={handBag} imgAlt="bag" imgClass="w-4 h-4" />
                  <span>Keep Shopping</span>
                </button>
                {/* <Filter
                  sections={[
                    {
                      label: 'Status',
                      name: 'status',
                      options: ['All', 'Order Confirmed', 'On the way', 'Delivered'],
                    },
                    {
                      label: 'Time',
                      name: 'time',
                      options: ['Anytime', 'Last 30 days', 'Last 6 months', 'Last year'],
                    },
                  ]}
                  onApply={(filters) => console.log(filters)}
                /> */}
              </div>

              {/* Mobile */}
              {/* <div className="lg:hidden">
                <Filter
                  sections={[
                    {
                      label: 'Status',
                      name: 'status',
                      options: ['All', 'Order Confirmed', 'On the way', 'Delivered'],
                    },
                    {
                      label: 'Time',
                      name: 'time',
                      options: ['Anytime', 'Last 30 days', 'Last 6 months', 'Last year'],
                    },
                  ]}
                  onApply={(filters) => console.log(filters)}
                />
              </div> */}
            </div>

            {/* Mobile Dropdown */}
            {open && (
              <div
                className="absolute top-full left-0 mt-2 w-full rounded-lg shadow-lg z-50 lg:hidden"
                style={{
                  backgroundColor: '#1d2a39',
                }}
              >
                <div className="flex flex-col gap-3 items-center mb-4 mt-3">
                  <div className="w-48">
                    <div
                      className="rounded px-5 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        border: 'solid 1px #f60',
                      }}
                    >
                      <CustomImage imageUrl={shoppingCart} imgAlt="cart" imgClass="w-4 h-4" />
                      <span>Wishlist</span>
                    </div>
                  </div>
                  <div className="w-48">
                    <div
                      className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        border: 'solid 1px #f60',
                      }}
                    >
                      <CustomImage
                        imageUrl={transactionIcon}
                        imgAlt="transaction"
                        imgClass="w-3 h-3"
                      />
                      <span>All Transactions</span>
                    </div>
                  </div>
                  <div className="w-48">
                    <div
                      className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                      }}
                    >
                      <CustomImage imageUrl={handBag} imgAlt="bag" imgClass="w-3 h-3" />
                      <span>Keep Shopping</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Orders Table */}
          {!isEmpty(orders) &&
            orders.map((order, index) => (
              <div
                key={order._id}
                style={{ border: '1px solid #ffffff60' }}
                className={`${index && 'mt-4'} rounded`}
              >
                {/* Order Row */}
                <div
                  className={`grid grid-cols-1 md:grid-cols-12 p-3 items-center`}
                  style={{
                    backgroundColor: '#1d2a39',
                    maxWidth: '890px',
                  }}
                >
                  {/* Order placed */}
                  <div className="md:col-span-2 relative">
                    <p className="text-gray-400 text-xs mb-1">Order placed</p>
                    <p className="text-white text-xs">{getReleaseDate(order.created_date)}</p>
                    <p
                      style={{ color: getStatusColor(order.order_status) }}
                      className="text-white text-xs absolute mt-1 "
                    >
                      {snakeToTitle(order.order_status)}
                    </p>
                  </div>

                  {/* Total items */}
                  <div className="md:col-span-2">
                    <p className="text-gray-400 text-xs mb-1">Total items</p>
                    <p className="text-white text-xs">{order?.products.length}</p>
                  </div>

                  {/* Total amount */}
                  <div className="md:col-span-2">
                    <p className="text-gray-400 text-xs mb-1">Total amount</p>
                    <p className="text-white text-xs">
                      {parseFloat(order.total_payable).toFixed(2)}{' '}
                      {getSymbolFromCurrency(order.currency || 'USD')}
                    </p>
                  </div>

                  {/* Ship to */}
                  <div className="md:col-span-2">
                    <p className="text-gray-400 text-xs mb-1 flex items-center">
                      Ship to
                      <IoIosInformationCircleOutline
                        style={{ color: '#fff' }}
                        className="h-4 w-4 cursor-pointer ml-2"
                        title={`${order?.user_address?.address}, ${order?.user_address?.city}, ${order?.user_address?.zipcode}`}
                      />
                    </p>
                    <p className="text-white text-xs">{order?.user_address?.name || ''}</p>
                  </div>

                  {/* Order number */}
                  <div className="md:col-span-2">
                    <p className="text-gray-400 text-xs mb-1">Order number</p>
                    <p
                      style={{
                        textWrap: 'wrap',
                        overflowWrap: 'anywhere',
                        wordWrap: 'break-word',
                        wordBreak: 'break-word',
                        width: '85%',
                      }}
                      className="text-white text-xs"
                    >
                      {order._id}
                    </p>
                  </div>

                  {/* Action buttons */}
                  <div className="md:col-span-2 flex flex-col gap-2">
                    <button
                      className="bg-transparent rounded px-4 py-1 text-sm flex justify-center items-center whitespace-nowrap"
                      style={{ color: '#e3e2e2', border: '1px solid #f60' }}
                      onClick={() => {
                        setSelectedTransaction(order)
                        setShowModal(true)
                      }}
                    >
                      Transaction detail
                    </button>
                    <button
                      className="flex items-center justify-center gap-1 text-sm font-medium cursor-pointer"
                      style={{ color: '#f60' }}
                      onClick={() => toggleOrderExpansion(order._id)}
                    >
                      <span>View detail</span>
                      <CustomImage
                        imageUrl={dropDownArror}
                        imgAlt="dropdown"
                        imgClass={`w-3 h-3 transform transition-transform duration-200 ${
                          expandedOrderId === order._id ? 'rotate-180' : ''
                        }`}
                      />
                    </button>
                  </div>
                </div>

                {/* Expanded Details */}
                {/* {expandedOrderId === order._id && order.products.length > 0 && ( */}
                <div
                  className=""
                  style={{
                    backgroundColor: '#182029',
                    // borderBottom: index < order.products.length - 1 ? '1px solid #2a3441' : 'none',
                    maxWidth: '890px',
                    overflow: 'hidden',
                    transition: 'height 0.4s ease, opacity 0.4s ease, padding 0.4s ease',
                    opacity: expandedOrderId === order._id ? 1 : 0,
                    maxHeight: expandedOrderId === order._id ? '3000px' : '0px',
                    padding: expandedOrderId === order._id ? '20px' : '0',
                  }}
                >
                  {order.products.map((item, itemIndex) => (
                    <div
                      key={item._id}
                      className={itemIndex > 0 ? 'mt-6 pt-6 border-t border-gray-600' : ''}
                    >
                      <div className="flex items-start gap-4 ">
                        {/* Product Image */}
                        <div className="bg-white rounded-lg flex items-center justify-center w-24 h-24 lg:w-28 lg:h-28 flex-shrink-0">
                          <CustomImage
                            imageUrl={getTemplateImage(getProductImage(item.img_s3_keys))}
                            imgAlt={item.title}
                            imgClass="w-full h-full object-cover rounded-lg"
                            loaderClass=" w-24 h-24 xl:w-28 lg:h-28 rounded-lg"
                          />
                        </div>

                        <div className="flex-1">
                          <div className="flex justify-between items-start">
                            <div className="flex-1 pr-4">
                              {/* Product Title */}
                              <p className="text-white font-semibold text-sm lg:text-base mb-3 line-clamp-2">
                                {item.title}
                              </p>

                              {/* Product Details */}
                              <div className="flex items-center gap-6 mb-2">
                                <div
                                  className="flex items-center gap-2"
                                  style={{ color: '#d1d1d1' }}
                                >
                                  <span className="text-xs">Quantity:</span>
                                  <span className="text-xs font-medium">{item.quantity}</span>
                                </div>
                              </div>

                              <div className="mb-2" style={{ color: '#d1d1d1' }}>
                                <span className="text-xs">
                                  Price: {item.price}{' '}
                                  <span className="uppercase">
                                    {getSymbolFromCurrency(order.currency || 'USD')}
                                  </span>
                                </span>
                              </div>
                              {!isEmpty(item?.metadata)
                                ? Object.keys(item?.metadata).map((key, index) => {
                                    return (
                                      <div
                                        className="mb-2"
                                        style={{ color: '#d1d1d1' }}
                                        key={index}
                                      >
                                        <span className="text-xs">
                                          {item?.metadata[key].name}: {item?.metadata[key].value}
                                        </span>
                                      </div>
                                    )
                                  })
                                : null}

                              <div className="flex items-center justify-between gap-2">
                                <div>
                                  <span
                                    className="text-sm font-medium"
                                    style={{ color: getStatusColor(item?.status) }}
                                  >
                                    {snakeToTitle(item?.status)}
                                  </span>

                                  <span className="text-sm ml-2" style={{ color: '#d1d1d1' }}>
                                    on {getReleaseDate(order.modified_date)}
                                  </span>
                                </div>

                                <div className="hidden md:flex justify-end gap-3">
                                  <button
                                    className="bg-transparent rounded px-4 py-2 text-sm font-medium whitespace-nowrap"
                                    style={{ color: '#e3e2e2', border: '1px solid #f60' }}
                                    onClick={() => {
                                      navigate(`/product/${item._id}`)
                                    }}
                                  >
                                    Buy it again
                                  </button>
                                </div>
                              </div>
                            </div>

                            {/* Desktop Action Buttons */}
                          </div>
                        </div>
                      </div>

                      {/* Mobile Action Buttons */}
                      <div className="md:hidden flex gap-2 mt-4">
                        <button
                          className="flex-1 bg-transparent rounded px-2 py-2 text-xs font-medium text-center"
                          style={{ color: '#e3e2e2', border: '1px solid #f60' }}
                          onClick={() => {
                            navigate(`/product/${item._id}`)
                          }}
                        >
                          Buy it again
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                {/* )} */}
              </div>
            ))}
        </div>
      </div>
      {showModal && (
        <TransactionDetailModal onClose={() => setShowModal(false)} order={selectedTransaction} />
      )}
    </div>
  )
}

export default OrderHistory
